import React from "react";
import { useSelector } from "react-redux";

const MarqueeBar = () => {
  const get_marques_List = useSelector(
    (state) => state?.allapi?.get_marques_List || {}
  );

  const about = get_marques_List?.about || [];

  if (about.length === 0) return null;

  return (
    <div
      className="marquee relative my-4 py-2"
      style={{
        background: "linear-gradient(135deg, #0c0c0c, #00a651 40%, #1a1a1a)",
      }}
    >
      <marquee behavior="scroll" direction="left" scrollamount="2">
        {about.map((item) => (
          <span key={item._id} className="gold-marquee-text">
            {item.title}&nbsp;&nbsp;
          </span>
        ))}
      </marquee>
    </div>
  );
};

export default MarqueeBar;




















// import React from "react";

// function MarqueeBar() {
//   const text =
//     "⚫ Network marketing में सफलता का असली मंत्र है—सकारात्मक सोच, सही सिस्टम और रोज़ की लगातार मेहनत।";

//   return (
//     <div className="marquee-bar my-3">
//       <div className="marquee-inner">
//         <span className="marquee-text">{text}</span>
//         <span className="marquee-text" aria-hidden="true">
//           {text}
//         </span>
//       </div>
//     </div>
//   );
// }

// export default MarqueeBar;
